const sessionCartData = () => {
  const addressSession = localStorage.getItem("ADDRESS_SESSION");
  const parsedAddressSession = addressSession ? JSON.parse(addressSession) : {};

  const couponSession = localStorage.getItem("COUPON_SESSION");
  const parsedCouponSession = couponSession ? JSON.parse(couponSession) : {
    discount_amount: 0.0,
    promo_id: 0,
    promo_code: "",
    cart_amount: 0.0,
  };

  const cartSession = localStorage.getItem("CART_SESSION");
  const parsedCartSession = cartSession ? JSON.parse(cartSession) : [];
  const parsedCartSummary = {
    itemTotal: 0.0,
    discount: 0,
    total_amount: 0.0,
    addon_amount: 0,
    sellingTotal: 0,
  };

  parsedCartSummary.itemTotal = parsedCartSession.reduce(
    (total, cartItem) => total + cartItem.product_price * cartItem.quantity,
    0
  );
  
  parsedCartSummary.sellingTotal = parsedCartSession.reduce(
    (total, cartItem) => total + cartItem.product_selling_price * cartItem.quantity,
    0
  );

  parsedCartSummary.discount = parsedCartSession.reduce(
    (total, cartItem) =>
      total +
      (cartItem.product_price - cartItem.product_selling_price) *
      cartItem.quantity,
    0
  );

  parsedCartSummary.addon_amount = parsedCartSession.reduce((totalAddon, cartItem) => {
    if (cartItem.product_tiffin_items?.length > 0) {
      return totalAddon + cartItem.product_tiffin_items.reduce((tiffinTotal, tiffinItem) => {
        if (tiffinItem.tiffin_category?.addon_category === 1) {
          const menuItemTotal = tiffinItem.menu_items.reduce((menuTotal, menuItem) => {
            const price = parseFloat(menuItem.item_price) || 0; // Default to 0 if invalid
            const quantity = Number(menuItem.qty) || 0; // Default to 0 if invalid
            return menuItem.isActive && quantity > 0
              ? menuTotal + price * quantity
              : menuTotal;
          }, 0);
          return tiffinTotal + menuItemTotal;
        }
        return tiffinTotal;
      }, 0);
    }
    return totalAddon;
  }, 0);

  parsedCartSummary.total_amount = parseFloat(parsedCartSummary.itemTotal) + parseFloat(parsedCartSummary.addon_amount) - parseFloat(parsedCartSummary.discount);

  const dataArr = [
    parsedAddressSession,
    parsedCartSession,
    parsedCouponSession,
    parsedCartSummary,
  ];

  return dataArr;
};

export default sessionCartData;
